import { Injectable, inject } from '@angular/core';

import { ConfigProviderService, ModularBingoClientConfig } from '@casinocore/platform/core';
import { BingoloaderService } from '@frontend/bingoloader';
import { OnAppInit } from '@frontend/vanilla/core';

@Injectable()
export class BingoBootstrapService implements OnAppInit {
    private readonly bingoLoaderService = inject(BingoloaderService);
    private readonly configProviderService = inject(ConfigProviderService);

    onAppInit() {
        //TODO: This needs to be discussed in detail more
        const bingoNPMModular: ModularBingoClientConfig = this.configProviderService.provideModularBingoClientConfig();
        if (bingoNPMModular?.isEnabled) {
            const environment = process.env.NODE_ENV;
            const params = {
                isDll: false,
            };
            this.bingoLoaderService.loadBingoNpmModule(environment ? environment : 'production', params);
        }
    }
}
